/**
 * Fix the bug because of the main nav structure and z-index problem
 * Should be removed when/if the main nav is restructured without the need of a
 * seperate div creating the background.
 * @param {Boolean} isHidden
 * @returns {Function}
 */
const navigationLogo = document.getElementById('nav__mobile__logo');
const navigationToggle = document.getElementById('nav__meta__md');

const handleNavItemHide = isHidden => {
    if (isHidden && window.innerWidth < 786) {
        navigationLogo.style.opacity = '0';
        navigationToggle.style.opacity = '0';
    } else if (isHidden && window.innerWidth < 1200) {
        navigationToggle.style.opacity = '0';
    } else {
        navigationLogo.style.opacity = '1';
        navigationToggle.style.opacity = '1';
    }
};

export default handleNavItemHide;



// WEBPACK FOOTER //
// ./src/scripts/components/filter-flyout/handleNavItemHide.js